import _ from "lodash"
import React from "react"
import { Navigate, useLocation } from "react-router-dom"

import { getSession, getCurrentUser } from "../helpers/AuthType/authService"

const Consolemiddleware = props => {
  try {
    const { pathname } = useLocation()
    let session = getSession()
    const user = getCurrentUser()
    
    if(_.isUndefined(session) ||  !_.has(session, 'console') || !session.console)
      return (
        <Navigate to={{ pathname: "/", state: { from: props.location } }} />
      )

    return <React.Fragment>{props.children}</React.Fragment>
  } catch (error) {
    return (
      <Navigate to={{ pathname: "/", state: { from: props.location } }} />
    )
  }
}

export default Consolemiddleware
